import request from '../../../Helpers/Request';

class Languages {
    constructor(settings) {
        this.settings = settings;
    }

    index(id) {
        return new Promise((resolve, reject) => {
            request('GET', `/clients/connections/${id}/languages`, this.settings)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    show(id, languageId) {
        return new Promise((resolve, reject) => {
            request('GET', `/clients/connections/${id}/languages/${languageId}`, this.settings)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    store(id, data) {
        return new Promise((resolve, reject) => {
            request('POST', `/clients/connections/${id}/languages/`, this.settings, data)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    update(id, languageId, data) {
        return new Promise((resolve, reject) => {
            request('PUT', `/clients/connections/${id}/languages/${languageId}`, this.settings, data)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    destroy(id, languageId) {
        return new Promise((resolve, reject) => {
            request('DELETE', `/clients/connections/${id}/languages/${languageId}`, this.settings)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    combineables(id) {
        return new Promise((resolve, reject) => {
            request('GET', `/clients/connections/${id}/languages/combineables`, this.settings)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }
}

export default Languages;
